import {observable, action} from 'mobx';
import {message} from '@enos/dpl';
import localeText from '@locale';
import Pagination from './Pagination';
import axiosInstance from '~/utils/axiosInstance';
import uris from '~/uris';
import Role from './models/Role';
import MenuGroup from './models/MenuGroup';
import Permission from './models/Permission';

export class RoleStore extends Pagination {
  @observable roleList = [];

  @observable isExist = Boolean;

  @observable menuGroups = [];

  @observable Permissions = [];

  @observable currentId = Number;

  @observable isLoading = false;

  @observable currentRole = {};

  @observable AppList = [];

  @observable menuGroupListWithAssigned = {};

  @observable permissionListWithAssigned = [];

  @observable structureListWithAssigned = [];

  @observable rolesLength;

  @observable availableSturctures = [];

  @action
  setRolesLength(num) {
    this.rolesLength = num;
  }

  @action('get role list')
  getRoleList(body = {}) {
    this.isLoading = true;
    axiosInstance.post(uris.getRoleList(), {...body}).then((data) => {
      this.setRoleList((data.roles || []).map(json => this.updateRoleListFromServer(json)));
      this.setPagination(data.pagination);
      this.setRolesLength((data.roles || []).length);
      this.setLoading();
    });
  }

  @action.bound
  getRoleListWithAddition(body = {}) {
    let data = {
      ...this.paginationRequestBody
    };

    if (this.rolesLength === 1 && body.isDelete) {
      data = {
        ...this.paginationRequestBodyBefore
      };
    }

    if (body.forceFresh) {
      data = {
        ...this.initPaginationRequestBody
      };
    }

    return this.getRoleList({
      ...data,
      ...body
    });
  }

  @action('get role list')
  getAppList() {
    axiosInstance.post(uris.getAppList(), {}).then((data) => {
      this.setAppList(data.apps);
    });
  }

  @action('get role list')
  getMenuGroupListWithAssigned(appId) {
    return axiosInstance.post(uris.getMenuGroupListWithAssigned(), null, {params: {roleId: this.currentRole.id, appId}}).then((data) => {
      this.setMenuGroupListWithAssigned(appId, data.menuGroups);
      return data.menuGroups;
    });
  }

  @action('get role list')
  getpermissionListWithAssigned(appId) {
    return axiosInstance.post(uris.getPermissionListWithAssigned(), null, {params: {roleId: this.currentRole.id, appId}}).then((data) => {
      this.setpermissionListWithAssigned(data.permissions);
      return data.permissions;
    });
  }

  @action.bound
  getStructureListWithAssigned(appId) {
    return axiosInstance
      .get(uris.getStructureListWithAssigned(), {
        params: {
          roleId: this.currentRole.id,
          appId
        }
      })
      .then((data) => {
        this.setStructureListWithAssigned(data.structures);
        return data.structures;
      });
  }

  @action.bound
  changePagination(pagination) {
    super.changePagination(pagination);
    this.getRoleListWithAddition();
  }

  @action('设置loading')
  setMenuGroupListWithAssigned(appId, json) {
    this.menuGroupListWithAssigned[appId] = json;
  }

  @action('设置loading')
  setpermissionListWithAssigned(json) {
    this.permissionListWithAssigned = json;
  }

  @action.bound
  setStructureListWithAssigned(data) {
    this.structureListWithAssigned = data;
  }

  @action('设置loading')
  setLoading(boolean) {
    this.isLoading = boolean;
  }

  @action('get role')
  setRole(data) {
    this.currentRole = this.updateRoleListFromServer(data);
  }

  @action('get one role')
  getRoleDetail(id) {
    axiosInstance
      .get(uris.getRoleDetail(), {
        params: {id}
      })
      .then((data) => {
        this.setRole(data);
      });
  }

  @action('get currentId')
  setCurrentId(id) {
    this.currentId = id;
  }

  @action('check role is exist')
  checkRoleExist(name, cb) {
    axiosInstance
      .post(uris.checkNameExist(), null, {
        params: {type: 'role', name},
        showError: {isShow: false}
      })
      .then((data) => {
        if (!data) {
          cb(false);
        } else {
          cb();
        }
      })
      .catch((error) => {
        cb(error);
      });
  }

  @action.bound
  deleteRole() {
    return axiosInstance
      .post(uris.deleteRole(), null, {
        params: {id: this.currentId},
        showError: {
          showPopup: true,
          title: localeText('COMMON.TITLE_DELETE_FAIL'),
          content: localeText('ROLE.WINMSG_ROLEDELETE_FAIL')
        }
      })
      .then(() => {
        message.success(localeText('ROLE.PRMTMSG_DELROLE_SUCCESS'));
        this.getRoleListWithAddition({isDelete: true});
      });
  }

  @action.bound
  deleteMenuGroup(roleId, menuGroupId) {
    axiosInstance
      .post(uris.deleteMenuGroup(), {
        roleId,
        menuGroupId
      })
      .then(() => {
        this.removeMGroup(menuGroupId);
        message.success(localeText('ROLE.PRMTMSG_REMMGROUP_SUCCESS'));
      });
  }

  // @action.bound
  // removeDeleteRole(role) {
  //   this.roleList.splice(this.roleList.indexOf(role), 1);
  // }

  @action('exist')
  toogleExist(data) {
    this.isExist = data;
  }

  @action.bound
  deletePermission(roleId, appId, permissionId) {
    axiosInstance
      .post(uris.deletePermission(), {
        roleId,
        appId,
        permissionId
      })
      .then(() => {
        this.removePermission(permissionId);
        message.success(localeText('ROLE.PRMTMSG_REMPERMISSION_SUCCESS'));
      });
  }

  @action.bound
  deleteAvailableStructure(appId, structureId, roleId) {
    axiosInstance
      .post(uris.deleteAvailableStructure(), {
        appId,
        structureId,
        roleId
      })
      .then(() => {
        this.removeStructure(structureId);
        message.success(localeText('ROLE.PRMTMSG_REMSTRUCTURE_SUCCESS'));
      });
  }

  @action('splice menuGroup visible')
  removeMGroup = (menuGroupId) => {
    const menuGroup = this.menuGroups.find(({id}) => id === menuGroupId);
    this.menuGroups.splice(this.menuGroups.indexOf(menuGroup), 1);
  };

  @action('splice Permission visible')
  removePermission = (permissionId) => {
    const permission = this.Permissions.find(({id}) => id === permissionId);
    this.Permissions.splice(this.Permissions.indexOf(permission), 1);
  };

  @action.bound
  removeStructure(structureId) {
    const structure = this.availableSturctures.find(({id}) => id === structureId);
    this.availableSturctures.splice(this.availableSturctures.indexOf(structure), 1);
  }

  @action('set role list')
  setRoleList(data) {
    this.roleList = data;
  }

  @action('set role list')
  setAppList(data) {
    this.AppList = data;
  }

  @action('clean MenuGroup')
  clearMenuGroup() {
    this.menuGroups = [];
  }

  @action('clean rolelist')
  clearPermissions() {
    this.Permissions = [];
  }

  @action('update rolelist')
  updateRoleListFromServer(json) {
    let role = this.roleList.find(({id}) => id === json.id);
    if (!role) {
      role = new Role(this, json.id);
    }
    role.updateFromJson(json);
    return role;
  }

  // @action('update rolelist')
  // updateAppListFromServer(json) {
  //   let app = this.AppList.find(({id}) => id === json.id);
  //   if (!app) {
  //     app = new App(this, json.id);
  //   }
  //   app.updateFromJson(json);
  //   return app;
  // }

  @action('update menugroup')
  updateMenuGroupFromServer(json) {
    let menugroup = this.menuGroups.find(({id}) => id === json.id);
    if (!menugroup) {
      menugroup = new MenuGroup(this, json.id);
      this.menuGroups.push(menugroup);
    }
    menugroup.updateFromJson(json);
    return menugroup;
  }

  @action('update Permissions')
  updatePermissionsFromServer(json) {
    let permission = this.Permissions.find(({id}) => id === json.id);
    if (!permission) {
      permission = new Permission(this, json.id);
      this.Permissions.push(permission);
    }
    permission.updateFromJson(json);
    return permission;
  }

  @action.bound
  setAvailableStructures(data) {
    this.availableSturctures = data;
  }

  @action('submit roledata')
  createRole(value) {
    axiosInstance.post(uris.createRole(), value).then((data) => {
      this.updateRoleListFromServer(data);
      this.getRoleListWithAddition({forceFresh: true});
      message.success(localeText('ROLE.PRMTMSG_ADDROLE_SUCCESS'));
    });
  }

  @action('modify role')
  modifyRole(value, id) {
    return axiosInstance.post(uris.modifyRole(), {id, name: value.name, description: value.description}).then((data) => {
      this.updateRoleListFromServer(data);
      this.getRoleDetail(id);
      message.success(localeText('ROLE.PRMTMSG_MODROLE_SUCCESS'));
    });
  }

  @action('get menuGroup')
  getMenuGroup(id) {
    axiosInstance
      .post(uris.getMenuGroup(), null, {
        params: {roleId: id}
      })
      .then((data) => {
        this.clearMenuGroup();
        (data.menuGroups || []).forEach((json) => {
          this.updateMenuGroupFromServer(json);
        });
      });
  }

  @action('get permissions')
  getPermission(id) {
    axiosInstance
      .post(uris.getPermissionAssign(), null, {
        params: {roleId: id}
      })
      .then((data) => {
        this.clearPermissions();
        (data.permissions || []).forEach((json) => {
          this.updatePermissionsFromServer(json);
        });
      });
  }

  @action.bound
  getStructure(id) {
    axiosInstance
      .get(uris.getStructureAssign(), {
        params: {roleId: id}
      })
      .then((data) => {
        this.setAvailableStructures(data.structures);
      });
  }

  @action
  assignMenuGroup(appId, menuGroupId) {
    return axiosInstance
      .post(uris.assignMenuGroup(), {
        roleId: this.currentRole.id,
        menuGroupId,
        appId
      })
      .then(() => {
        message.success(localeText('ROLE.PRMTMSG_ASSMGROUP_SUCCESS'));
      });
  }

  @action
  assignPermission(appId, permissionIds) {
    return axiosInstance.post(uris.assignPermission(), {roleId: this.currentRole.id, appId, permissionIds}).then(() => {
      message.success(localeText('ROLE.PRMTMSG_ASSPERMISSION_SUCCESS'));
    });
  }

  @action.bound
  assignStructure(appId, structureId) {
    return axiosInstance
      .post(uris.assignStructure(), {
        roleId: this.currentRole.id,
        appId,
        structureId
      })
      .then(() => {
        message.success(localeText('ROLE.PRMTMSG_ASSSTRUCTURE_SUCCESS'));
      });
  }

  @action
  modifyCurrentRole(name, description) {
    this.currentRole.name = name;
    this.currentRole.description = description;
  }
}

export default new RoleStore();
